import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    organizations: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        page: null,
        pages: null,
        rowsPerPage: 25,
    },
    statusText: ""
};

export default createReducer(initialState, {
    [C.GET_ORGANIZATIONS_REQUEST]: (state) => ({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: true,
        }
    }),
    [C.GET_ORGANIZATIONS_FAILURE]: (state) => ({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка организаций."
    }),
    [C.GET_ORGANIZATIONS_SUCCESS]: (state, payload) =>({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: false,
            isLoaded: true,
            data: payload.organizations,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    }),
    [C.CREATE_ORGANIZATION]: (state, payload) => ({
        ...state,
        organizations: {
            ...state.organizations,
            data: [
                ...state.organizations.data,
                payload
            ].sort((a, b) => (a.id > b.id ? 1 : -1)),
            count: state.organizations.count + 1
        }
    }),
    [C.CREATE_ORGANIZATION_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка создания организации."
    }),
    [C.EDIT_ORGANIZATION]: (state, payload) => {
        return {
            ...state,
            organizations: {
                ...state.organizations,
                data: state.organizations.data.map(organization => (organization.id !== payload.id ? organization : payload)),
            }
        }},

    [C.EDIT_ORGANIZATION_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка редактирования организации."
    }),
    [C.DELETE_ORGANIZATION]: (state, payload) => ({
        ...state,
        organizations: {
            ...state.organizations,
            data: state.organizations.data.map(organization => (organization.id !== payload ? organization : null)).filter(n => n),
            count: state.organizations.count - 1,
        }
    }),
});


// WEBPACK FOOTER //
// ./src/reducers/organizations.js